import { getGetAssetModelsUrl } from 'generatedTypes/asset/services/asset-model-controller';
import { useState } from 'react';

import useFetch from 'hooks/useFetch';
import useRetry from 'hooks/useRetry';

import useTranslation from './hooks/useTranslation';

import type { AssetModelResponse, FetchAssetModels, UseAssetModels } from './types';

const useAssetModels = (): UseAssetModels => {
    const [assetModels, setAssetModels] = useState<AssetModelResponse[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const { authenticatedGet } = useFetch();
    const { withRetry } = useRetry();
    const { CONNECTION_ERROR } = useTranslation();

    const fetchAssetModels: FetchAssetModels = async () => {
        try {
            setIsLoading(true);

            const models = await withRetry(
                () => authenticatedGet<AssetModelResponse[]>(getGetAssetModelsUrl()),
                CONNECTION_ERROR,
                fetchAssetModels
            );

            setAssetModels(models ?? []);

            return models;
        } finally {
            setIsLoading(false);
        }
    };

    return {
        assetModels,
        fetch: fetchAssetModels,
        isLoading
    };
};

export default useAssetModels;
